<script>
export default {
    beforeCreate(){
        parent?.window?.nicepayComplete?.(this.$route.query);
        opener?.window?.nicepayComplete?.(this.$route.query);
        if(parent || opener) window.close();
    },
}
</script>